export const PARTNER_DISCOUNT_TYPE = 'PARTNER_DISCOUNT';
export const PARTNER_MARGIN_TYPE = 'PARTNER_MARGIN';
export const CORPORATE_RESELLER_PARTNER = 'Corporate Reseller';
export const AGGREGATOR_PARTNER = 'Aggregator';
